import { httpClient } from "@/services";
export default {
	state: {
		trucksValueFilter: null,
		trucksValueList: null,
		trucksValueYears: null,
		originValue: null,
	},
	mutations: {
		updateTrucksValue(state, { years, filter, trucks, originValue }) {
			state.trucksValueYears = years;
			state.trucksValueFilter = filter;
			state.trucksValueList = trucks;
			state.originValue = originValue;
		}
	},
	actions: {
		async onTrucksValue({ commit, dispatch }, id) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.get(`/trucks/value/${ id }`);
				if (data && !data.error) {
					commit('updateTrucksValue', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onTrucksValueRemove({ dispatch }, { id, trailerId }) {
			dispatch("actionPreloader", true);
			const { data } = await httpClient.delete(`/trucks/value/${ id }`);

			if (data && data.status) {
				dispatch('setAlert', { type: "success", message: "Remove notes item" });
				dispatch('onTrucksValue', trailerId);
				dispatch("actionPreloader", false);
			}
		},
		async onTrucksValueCreate({ dispatch }, { truckId, values }) {
			const { id } = values;
			const url = id ? `/trucks/value/${ id }/update` : `/trucks/value/${ truckId }/store`;
			const message = id ? "Updated value item" : "Created value item";

			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.post(url, values);
				if (data && data.status) {
					dispatch('setAlert', { type: "success", message });
					await dispatch('onTrucksValue', truckId);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		async onTrucksValueEdit({ dispatch }, id) {
			dispatch("actionPreloader", true);
			const { data } = await httpClient.get(`/trucks/value/${ id }/edit`);
			if (data && !data.status) {
				dispatch("actionPreloader", false);
				return data.values;
			}
		},
	},
	getters: {
		trucksValueFilter: s => s.trucksValueFilter,
		trucksValueList: s => s.trucksValueList,
		trucksValueYears: s => s.trucksValueYears,
		originValue: s => s.originValue,
	}
};
